import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCryptocurrency = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	stroke: "currentColor",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.7669 19.0887C16.6909 19.9567 17.9069 13.0637 12.9829 12.1947M11.7669 19.0887L5.85986 18.0467M11.7669 19.0887L11.4209 21.0587M9.04386 11.5007L12.9839 12.1947C17.9079 13.0637 19.1239 6.16972 14.1989 5.30172L8.28986 4.25972M14.1979 5.30172L14.5459 3.33172M7.47986 20.3637L10.6059 2.63672",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCryptocurrency;
